import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsWaterNormalLarge = React.forwardRef(
  ({ color = "currentColor", size = 48, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="">
        <path d="M32.57 6.65a1.5 1.5 0 00-2.473 0C28.505 8.967 26.606 10 24 10s-4.504-1.033-6.097-3.35l-2.472 1.7C17.538 11.414 20.329 13 24 13c2.994 0 5.403-1.055 7.333-3.107C33.264 11.945 35.672 13 38.667 13c3.67 0 6.462-1.586 8.57-4.65l-2.473-1.7C43.171 8.967 41.272 10 38.667 10c-2.606 0-4.505-1.033-6.097-3.35zM16.667 20a1.5 1.5 0 011.236.65C19.496 22.967 21.395 24 24 24c2.606 0 4.505-1.033 6.097-3.35a1.5 1.5 0 012.472 0c1.593 2.317 3.492 3.35 6.097 3.35s4.505-1.033 6.098-3.35l2.472 1.7C45.13 25.414 42.338 27 38.666 27c-2.994 0-5.403-1.055-7.332-3.107C29.404 25.945 26.994 27 24 27s-5.403-1.055-7.333-3.107C14.737 25.945 12.327 27 9.333 27c-3.67 0-6.462-1.586-8.57-4.65l2.473-1.7C4.83 22.967 6.728 24 9.333 24c2.606 0 4.505-1.033 6.098-3.35a1.5 1.5 0 011.236-.65zM16.667 34a1.5 1.5 0 011.236.65C19.496 36.967 21.395 38 24 38c2.606 0 4.505-1.033 6.097-3.35l2.472 1.7C30.463 39.414 27.671 41 24 41c-2.994 0-5.403-1.055-7.333-3.107C14.737 39.945 12.327 41 9.333 41c-3.67 0-6.462-1.586-8.57-4.65l2.473-1.7C4.829 36.967 6.728 38 9.333 38c2.606 0 4.505-1.033 6.098-3.35a1.5 1.5 0 011.236-.65z" />
      </g>
    </svg>
  )
);
SvgSportsWaterNormalLarge.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsWaterNormalLarge;
